// Reducer for per-table column visibility + ordering preferences
export const initialTableState = {
    columnPreferences: {} // Keyed by `tabKey` → { savedOrder, allowedKeys }
};

export const tableReducer = (state = initialTableState, action) => {
    switch (action.type) {
        case 'SET_COLUMN_PREFERENCE':
            return {
                ...state,
                columnPreferences: {
                    ...state.columnPreferences,
                    [action.payload.key]: {
                        ...state.columnPreferences[action.payload.key],
                        ...action.payload.preference
                    }
                }
            };
        case 'CLEAR_COLUMN_PREFERENCES':
            return initialTableState;
        default:
            return state;
    }
};
